import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredSelect(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (value === null || value === undefined) return { required: true };
  if (value === '' || value === 0) return { required: true };

  return null;
}
